import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    alignSelf: "flex-start",
    flexDirection: "column",
    /* padding: 12, */
    /*  marginTop: 30, */
    marginBottom: 20,
    alignItems: "flex-start",
    /*  borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4, */
  },
  imageContainer: {
    width: 300,
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  imgCoin: {
    width: 46,
    height: 46,
    borderRadius: 50,

    alignSelf: "left",
  },
  nameCoin: {
    fontWeight: "bold",
    width: 200,
   /*  marginLeft: "6%", */
    fontSize: 16,
    marginBottom: 6,
  },
  priceCoin: {
 /*    marginLeft: "6%", */
    fontSize: 16,
  },
  amountCirculation: {
    fontSize: 14,
    marginTop: 5,
    fontWeight: "400",
  },
});

export default styles;
